import { action } from 'typesafe-actions';
import { KpiEAITypes, IKpi } from './types';

export const loadRequest = (cd: number, inscricao: number[], card: string, agrupar: number) =>
  action(KpiEAITypes.LOAD_REQUEST, {
    cd,
    agrupar,
    card,
    inscricao,
  });

export const loadSuccess = (data: IKpi[]) => action(KpiEAITypes.LOAD_SUCCESS, { data });

export const loadFailure = () => action(KpiEAITypes.LOAD_FAILURE, {});
